import React, { useState, useRef, useEffect } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './LanguageToggle.css';

const LANGS = [
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'fr', short: 'FR', label: 'Français' },
];

export default function LanguageToggle() {
  const { appLanguage, setAppLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onOutsideClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener('mousedown', onOutsideClick);
    return () => document.removeEventListener('mousedown', onOutsideClick);
  }, [open]);

  const current = LANGS.find(l => l.code === appLanguage) || LANGS[0];

  return (
    <div className="lang-toggle" ref={ref}>
      <button
        className="lang-toggle-btn notranslate"
        onClick={() => setOpen(o => !o)}
        title="Change language / Changer de langue"
        translate="no"
      >
        <Globe size={14} />
        <span className="notranslate">{current.short}</span>
      </button>

      {open && (
        <div className="lang-toggle-dropdown notranslate" translate="no">
          {LANGS.map(lang => (
            <button
              key={lang.code}
              className={`lang-toggle-option notranslate${appLanguage === lang.code ? ' active' : ''}`}
              onClick={() => { setAppLanguage(lang.code); setOpen(false); }}
            >
              <span className="lang-toggle-short notranslate">{lang.short}</span>
              <span className="lang-toggle-label notranslate">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
